import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import type { MouseEventHandler } from 'react'
import React, { useCallback, useContext } from 'react'

interface Props {
  isLoginForMemberSavings?: boolean
  kind?: 'primary' | 'secondary' | 'tertiary'
}

function BedbankMetaSearchTileSignUpButton({ isLoginForMemberSavings, kind = 'primary' }: Props) {
  const showModal = useContext(ModalContext)
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    showModal(<AccountAccessModal />)
  }, [showModal])

  if (isLoginForMemberSavings) {
    return <TextButton kind={kind} nonInteractable onClick={handleClick}>
      Sign up & save more
    </TextButton>
  }

  return <TextButton kind={kind} nonInteractable onClick={handleClick}>
    Sign up for free
  </TextButton>
}

export default BedbankMetaSearchTileSignUpButton
